export enum CodeSearchStoreEnum {
  FIREBASE_LOADING_KEY = 'firebaseLoadingKey',
  TYPE = 'type',
  CODE_SEARCH_TYPE = 'codeSearchType',
  CODE_SEARCH_QUERY = 'codeSearchQuery',
  CODE_SEARCH_RMN = 'codeSearchRmn',
  CODE_SEARCH_METADATA_TYPES = 'codeSearchMetadataTypes',
  CODE_SEARCH_DATA$ = 'codeSearchData$',
  CODE_SEARCH_TOTAL$ = 'codeSearchTotal$',
  CODE_SEARCH_WHERE_TYPES$ = 'codeSearchWhereTypes$'
}
